import { render, staticRenderFns } from "./DemoSimpleTableFixedHeader.vue?vue&type=template&id=20e1d8c5&"
import script from "./DemoSimpleTableFixedHeader.vue?vue&type=script&lang=js&"
export * from "./DemoSimpleTableFixedHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
